// „Сторнирай всичко", спряно от склада: сметката е от РАЗНЕСЕН отчет, а
// връщането на стоката ѝ гръмна. BE връща 409 `detail = {code:
// "cancel_all_stock_failed", reason, message}` (`bills/service_cancel_all_stock.py`)
// — нищо не е сторнирано и нищо не е отпечатано (складът се пипа ПРЕДИ
// печата на сторно бона, в една транзакция). Кодът е кросрепо литерал
// (docs/cross-repo-contract.md); текстът се превежда тук, `message` от BE е
// само резервът за клиент без превод.
import type { TFunction } from "i18next";

export const CANCEL_ALL_STOCK_FAILED_CODE = "cancel_all_stock_failed";

type StockFailureDetail = { code?: unknown; reason?: unknown };

// Причината от отказа на склада или null, ако грешката е друга
export const cancelAllStockFailureReason = (error: unknown): string | null => {
  const response = (error as { response?: { status?: number; data?: { detail?: unknown } } } | null)?.response;
  const detail = response?.data?.detail;
  if (response?.status !== 409 || !detail || typeof detail !== "object") return null;
  const { code, reason } = detail as StockFailureDetail;
  if (code !== CANCEL_ALL_STOCK_FAILED_CODE) return null;
  return typeof reason === "string" && reason.trim() ? reason.trim() : "?";
};

// Заглавието и текстът на прозореца за оператора
export const cancelAllStockFailureTexts = (t: TFunction, reason: string) => ({
  title: t("reportsPage.billOpsCancelStockFailedTitle"),
  text: t("reportsPage.billOpsCancelStockFailedText", { reason }),
});
